import React, { createContext, useReducer } from "react";
//import FnrEnvironment from "Utilities/FnrEnvironment";
//import { devInitialAppState } from "./state.dev.js";

const initialAppState = {
  overlays: [],
  scrollableRef: null,
};

function appReducer(state, action) {
  let newState = { ...state };

  let foundOverlay;

  switch (action.type) {
    //mostly comes calls outside of React
    case "fn_key_value":
      newState[action.key] = action.value;
      return newState;

    case "Set Scrollable Ref":
      newState.scrollableRef = action.ref;
      return newState;

    case "Show an Overlay":
      if (
        newState.overlays.length === 0 ||
        !newState.overlays.find((ol) => ol.ref === action.overlay.ref)
      )
        newState.overlays.push(action.overlay);
      return newState;
    case "Hide an Overlay":
      foundOverlay = newState.overlays
        .map((ol) => ol.ref)
        .indexOf(action.overlay.ref);
      if (foundOverlay >= 0) newState.overlays.splice(foundOverlay, 1);
      return newState;

    default:
      return newState;
  }
}

export const AppState = createContext();

export default function AppStateProvider({ networkID, children }) {
  if (networkID) initialAppState.networkID = networkID;

  let newInitialAppState = initialAppState;

  //if (FnrEnvironment.useDevState()) newInitialAppState = { ...initialAppState, ...devInitialAppState };

  const value = useReducer(appReducer, newInitialAppState);
  return <AppState.Provider value={value}>{children}</AppState.Provider>;
}
